import { Col } from "react-bootstrap";
import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link, useNavigate, useParams, state } from "react-router-dom";

export default function ExpendituresCardComponent({ data, formState }) {

	const { t } = useContext(TranslatorContext);
	const navigate = useNavigate();
	const totalperson = data?.total_children_rescued
		+ data?.total_female_rescued + data?.total_male_rescued

	const { key } = useParams();

	const handleCardClick = (key,category="loan_expense") => {

		formState.key = key;
		formState.category = category;
        
		navigate(`/dashboard-count-list`, { state: formState });
	};

	const floats = [
		{
			key: "total_loan_paid",
			title: "Total Paid Loan",
			digit: data?.total_loan_paid,
			icon: "payments",
			variant: "lg blue",
		},
		{
			category:"business_expense",
			key: "business_cost",
			title: "Business Cost",
			digit: data?.business_cost,
			icon: "business_center",
			variant: "lg blue",
		},
		{
			key: "medical_amount",
			title: "Medical Treatment",
			digit: data?.total_medical_expense,
			icon: "medication",
			variant: "lg blue",
		},
		{
			key: "food_ration",
			title: "Food Ration",
			digit: data?.total_foodration_expense,
			icon: "emoji_food_beverage",
			variant: "lg blue",
		},
		{
			key: "rent_amount",
			title: "Rent Amount",
			digit: data?.total_rent_expense,
			icon: "money",
			variant: "lg blue",
		},
		{
			key: "utility_amount",
			title: "Utility Amount",
			digit: data?.total_utility_expense,
			icon: "list_alt",
			variant: "lg blue",
		},
		{
			key: "khatta_amount",
			title: "Khatta Amount",
			digit: data?.total_khatta_expense,
			icon: "view_array",
			variant: "lg blue",
		},
		{
			title: "Meal Amount",
			digit: data?.total_meal_expense,
			key: "meal_amount",
			icon: "rice_bowl",
			variant: "lg blue",
		},
		{
			key: " transportation",
			title: "Transportation Amount",
			digit: data?.total_transportation_expense,
			icon: "electric_rickshaw",
			variant: "lg blue",
		},
		{
			title: "Education Amount",
			key: "followup_education_amount",
			digit: data?.followup_education_amount,
			icon: "school",
			variant: "lg blue",
		},
		{
			title: "Resettlement Amount",
			digit: data?.total_resettlement_amount,
			key: "total_resettlement_amount",
			icon: "forward",
			variant: "lg blue",
		},
		{
			key: "other_amount",
			title: "OtherPayment",
			digit: data?.total_other_amount,
			icon: "devices_other",
			variant: "lg blue",
		},
		{
			key: "total_budget_expenditure",
			title: "Total Budget Spent",
			digit: data?.total_budget_expenditure,
			icon: "note_alt",
			variant: "lg blue",
		},
		{
			noclick: true,
			key: "total_loan_paid",
			title: "Average Debt Per Family",
			digit:
				data?.total_loan_paid > 0
					? Math.round(
						data?.total_loan_paid / data?.total_families_rescued
					)
					: 0,
			icon: "live_help",
			variant: "lg blue",
		},
		{
			noclick: true,
			key: "avg_loan_person",//key is not set yet
			title: "Average Debt Per Person",
			digit:data?.total_loan_paid > 0
				? Math.round(
					data?.total_loan_paid / totalperson
				)
				: 0,
			icon: "tour",
			variant: "lg blue",
		},
	];
	return (
		<>
			{floats.map((data, index) => {
				return (
					<Col
						key={index}
						sm={6}
						lg={4}
					>
						<div
							className={`mc-float-card ${data.variant}`}
							onClick={() => !data.noclick && handleCardClick(data.key, data.category)}

							style={{
								background:
									"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
								cursor: "pointer"
							}}
						>
							<h3>{data.digit}</h3>
							<p>{data.title}</p>
							<i
								className="material-icons"
								style={{ color: "#077834" }}
							>
								{data.icon}
							</i>
						</div>
					</Col>
				);
			})}
		</>
	);
}
